module.exports = __webpack_public_path__ + "media/assets/img/company/logo INAredi-4d66ef38ae54499682de27244af6d04f.png";